import store from '@/store'
import { Message } from 'element-ui'
import { authHeader } from '@/services/auth'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
export default {
  namespaced: true,
  state: {
    loadingStatus: false,
    modalDelete: false,
    modelIdToDelete: null,
    filter: {
      page: 1,
      limit: 10
    },
    filterReseau: {
      page: 1,
      limit: 10
    },
    results: {
      list: [],
      total: 0
    },
    resultsReseau: {
      list: [],
      total: 0
    }
  },
  getters: {
    filter: (state) => state.filter,
    page: (state) => state.filter.page,
    limit: (state) => state.filter.limit,
    list: (state) => state.results.list,
    total: (state) => state.results.total,
    loadingStatus: (state) => state.loadingStatus,
    modalDelete: (state) => state.modalDelete,
    modelIdToDelete: (state) => state.modelIdToDelete,
    listReseau: (state) => state.resultsReseau.list,
    totalReseau: (state) => state.resultsReseau.total,
    filterReseau: (state) => state.filterReseau,
    pageReseau: (state) => state.filterReseau.page,
    limitReseau: (state) => state.filterReseau.limit
  },
  mutations: {
    SET_LOADING_STATUS (state, loadingStatus) {
      state.loadingStatus = loadingStatus
    },
    SET_MODAL_DELETE (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    SET_MODEL_ID_TO_DELETE (state, modelIdToDelete) {
      state.modelIdToDelete = modelIdToDelete
    },
    setPage (state, page) {
      state.filter.page = page
    },
    setLimit (state, limit) {
      state.filter.page = 1
      state.filter.limit = limit
    },
    setTotal (state, total) {
      state.results.total = total
    },
    setList (state, list) {
      state.results.list = list
    },
    setListReseau (state, list) {
      state.resultsReseau.list = list
    },
    setTotalReseau (state, total) {
      state.resultsReseau.total = total
    },
    setPageReseau (state, page) {
      state.filterReseau.page = page
    },
    setLimitReseau (state, limit) {
      state.filterReseau.limit = limit
    }
  },
  actions: {
    loadModels ({ getters, commit }) {
      commit('SET_LOADING_STATUS', true)
      let url = '/annonce?universe=EDITO&etat=M'
      url = url + '&page=' + getters.page
      url = url + '&perPage=' + getters.limit

      return HTTP_HYPER_ESPACE_BACKEND
        .get(url)
        .then(response => {
          if (response.data._embedded.annonce) {
            const objResponse = {
              total: response.data.total_items,
              list: response.data._embedded.annonce
            }
            commit('setList', objResponse.list)
            commit('setTotal', objResponse.total)
          }
        }).catch(error => {
          console.log({ type: 'error', message: error })
          commit('SET_LOADING_STATUS', false)
        })
        .finally(function () {
          commit('SET_LOADING_STATUS', false)
        })
    },
    loadModelsReseau ({ getters, commit }) {
      commit('SET_LOADING_STATUS', true)
      let url = '/annonce?universe=EDITO&etat=M&get_model_annonce_parent_edito=1'
      url = url + '&page=' + getters.pageReseau
      url = url + '&perPage=' + getters.limitReseau

      return HTTP_HYPER_ESPACE_BACKEND
        .get(url)
        .then(response => {
          commit('setListReseau', response.data._embedded.annonce)
          commit('setTotalReseau', response.data.total_items)
          commit('SET_LOADING_STATUS', false)
        })
        .finally(function () {
          commit('SET_LOADING_STATUS', false)
        })
    },
    deleteModel (context, id) {
      context.commit('SET_LOADING_STATUS', true)

      const url = '/annonce'
      const params = {
        data: [id]
      }

      return HTTP_HYPER_ESPACE_BACKEND
        .delete(url, params)
        .then(response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(function () {
          context.commit('SET_MODAL_DELETE', false)
          context.commit('SET_MODEL_ID_TO_DELETE', null)
          context.commit('SET_LOADING_STATUS', false)
        })
    }
  }
}
